import axios from 'axios'
import React from 'react'
import { t } from '../../i18n'

const scope = 'replenishment.banner'

const ImpersonatingNotice = ({ impersonatingUser, isImpersonating }) => {
  if (!isImpersonating) {
    return
  }

  const stopImpersonating = async () => {
    axios.post('/admin/organizations/stop_impersonating').then(({ data }) => {
      window.location.href = data.redirect_to
    }).catch((error) => {
      console.error('Error stopping impersonation:', error)
    })
  }

  return (
    <div className="header-notice-content">
      <div className="header-notice">
        <span>{ t('navbar.user.signed_in_as_user', { first_name: impersonatingUser.first_name, last_name: impersonatingUser.last_name }) }</span>
        <span className="green underlined" style={{marginLeft: '10px'}} onClick={stopImpersonating}>{t('navbar.user.sign_out')}</span>
      </div>
    </div>
  )
}

export default ImpersonatingNotice
